export default {
    getAllHomes: env => {
        return {
            url: `/${env}/homes`,
            method: 'GET',
        };
    },
    getHomeDetails: (env, homeId) => {
        return {
            url: `/${env}/homes/:homeId`,
            method: 'GET',
            route_params: {
                homeId,
            },
        };
    },
    updateHomeDetails: (env, homeId, homeForm) => {
        let params = {};
        Object.keys(homeForm).map(field => {
            if (homeForm[field] !== null) params[field] = homeForm[field];
        });
        return {
            url: `/${env}/homes/:homeId`,
            method: 'PATCH',
            route_params: {
                homeId,
            },
            patch_params: { ...params, isThreephase: !!homeForm.isThreephase },
        };
    },
    autocompleteBoxMac: (env, macAddr) => {
        return {
            url: `/${env}/boxes/autocomplete`,
            method: 'GET',
            get_params: {
                macAddr,
            },
        };
    },
    dissociateBox: (env, macAddress, homeId) => {
        return {
            url: `/${env}/boxes/:macAddress/dissociate`,
            method: 'POST',
            route_params: {
                macAddress,
            },
            post_params: {
                homeId,
            },
        };
    },
    addHome: (env, form) => {
        const params = {};
        const homeForm = {};
        Object.keys(form.home).map(field => {
            if (form.home[field] !== null) homeForm[field] = form.home[field];
        });
        params.home = homeForm;

        if (form.user) {
            const userForm = {};
            Object.keys(form.user).map(field => {
                if (form.user[field] !== null) userForm[field] = form.user[field];
            });
            params.user = userForm;
        }

        return {
            url: `/${env}/homes/add`,
            method: 'PATCH',
            patch_params: params,
        };
    },
    resetPassword: (env, userId, homeId) => {
        return {
            url: `/${env}/users/:userId/reset-password`,
            method: 'POST',
            route_params: {
                userId,
            },
            post_params: {
                homeId,
            },
        };
    },
    resendWelcomeUserEmail: (env, userId, homeId) => {
        return {
            url: `/${env}/users/:userId/resend-welcome-message`,
            method: 'POST',
            route_params: {
                userId,
            },
            post_params: {
                homeId,
            },
        };
    },
    getHomeUsers: (env, homeId) => {
        return {
            url: `/${env}/homes/:homeId/users`,
            method: 'GET',
            route_params: {
                homeId,
            },
        };
    },
    deleteHomeUser: (env, homeId, userId) => {
        return {
            url: `/${env}/homes/:homeId/delete-user`,
            method: 'POST',
            route_params: {
                homeId,
            },
            post_params: {
                userId,
            },
        };
    },
    deleteHomeUserAndSwitchMaster: (env, homeId, userId, masterId) => {
        return {
            url: `/${env}/homes/:homeId/delete-user-and-switch-master`,
            method: 'POST',
            route_params: {
                homeId,
            },
            post_params: {
                userId,
                masterId,
            },
        };
    },
    switchHomeMaster: (env, homeId, masterId) => {
        return {
            url: `/${env}/homes/:homeId/switch-master`,
            method: 'POST',
            route_params: {
                homeId,
            },
            post_params: {
                masterId,
            },
        };
    },
    addHomeUser: (env, homeId, userForm) => {
        let params = {};
        Object.keys(userForm).map(field => {
            if (userForm[field] !== null && userForm[field] !== '') params[field] = userForm[field];
        });

        return {
            url: `/${env}/homes/:homeId/add-users`,
            method: 'POST',
            route_params: {
                homeId,
            },
            post_params: params,
        };
    },
    addSpecialHomeUser: (env, homeId, userForm) => {
        let params = {};
        Object.keys(userForm).map(field => {
            if (userForm[field] !== null && userForm[field] !== '') params[field] = userForm[field];
        });

        return {
            url: `/${env}/homes/:homeId/add-special-users`,
            method: 'POST',
            route_params: {
                homeId,
            },
            post_params: params,
        };
    },
    editHomeUser: (env, homeId, userId, userForm) => {
        let params = {};
        Object.keys(userForm).map(field => {
            if (userForm[field] !== null && userForm[field] !== '') params[field] = userForm[field];
        });
        return {
            url: `/${env}/homes/:homeId/edit-user/:userId`,
            method: 'PATCH',
            route_params: {
                homeId,
                userId,
            },
            patch_params: params,
        };
    },
    getHomeTickets: (env, homeId) => {
        return {
            url: `/${env}/homes/:homeId/tickets`,
            method: 'GET',
            route_params: {
                homeId,
            },
        };
    },
    getHomeHistory: (env, homeId, withActions) => {
        return {
            url: `/${env}/homes/:homeId/history`,
            method: 'GET',
            route_params: {
                homeId,
            },
            get_params: {
                withActions,
            },
        };
    },
    addHomeHistory: (env, homeId, historyForm) => {
        let params = {};
        Object.keys(historyForm).map(field => {
            if (historyForm[field] !== null) params[field] = historyForm[field];
        });
        return {
            url: `/${env}/homes/:homeId/add-history`,
            method: 'POST',
            route_params: {
                homeId,
            },
            post_params: params,
        };
    },
    getJournalisation: (env, homeId, fromDate, toDate) => {
        return {
            url: `/${env}/homes/:homeId/journalisation`,
            method: 'GET',
            route_params: {
                homeId,
            },
            get_params: {
                fromDate,
                toDate,
            },
        };
    },
    getStats: (env, homeId, fromDate) => {
        return {
            url: `/${env}/homes/:homeId/get-autoconso`,
            method: 'GET',
            route_params: {
                homeId,
            },
            get_params: {
                fromDate,
            },
        };
    },
    emailExists: (env, email) => {
        return {
            url: `/${env}/homes/email-exists/:email`,
            method: 'GET',
            route_params: {
                email,
            },
        };
    },
};



// WEBPACK FOOTER //
// ./environments/genericEnv/data/Homes/api.js